<template>
    <Modal v-model="show"
        :width="80"
        :footer-hide="true"
        title="备用库入库单详情"
        class-name="vertical-center-modal"
        @on-visible-change="onShowChange">
        <Spin v-if="innerSpin"
            size="large"
            fix></Spin>
        <Card :padding="0"
            :bordered="false"
            :dis-hover="true">
            <Row :gutter="16">
                <Col span="24">
                <Form ref="warehouseForwardEntryFrom"
                    label-position="top"
                    class="small-form">
                    <Row :gutter="16">
                        <Col span="4">
                        <FormItem label="单号">
                            <Input :value="warehouseForwardEntryFrom.record.warehouseForwardEntryRecordBillCode"
                                readonly></Input>
                        </FormItem>
                        </Col>

                        <Col span="4">
                        <FormItem label="批次">
                            <Input :value="warehouseForwardEntryFrom.record.warehouseForwardEntryRecordBatchCode"></Input>
                        </FormItem>
                        </Col>

                        <Col span="4">
                        <FormItem label="项目">
                            <Input :value="warehouseForwardEntryFrom.record.warehouseForwardEntryRecordProject"></Input>
                        </FormItem>
                        </Col>

                        <Col span="4">
                        <FormItem label="电话">
                            <Input :value="warehouseForwardEntryFrom.record.warehouseForwardEntryRecordContactNumber"></Input>
                        </FormItem>
                        </Col>

                        <Col span="4">
                        <FormItem label="制单时间">
                            <Input :value="formatWarehouseForwardEntryRecordCreateAt"
                                readonly></Input>
                        </FormItem>
                        </Col>

                        <Col span="4">
                        <FormItem label="制单人">
                            <Input :value="warehouseForwardEntryFrom.ownerName"
                                readonly></Input>
                        </FormItem>
                        </Col>
                    </Row>
                </Form>
                </Col>
            </Row>

            <Row :gutter="16">
                <Col span="24">
                <Card class="thin-card-title"
                    :padding="0"
                    :bordered="false"
                    :dis-hover="true">
                    <p slot="title">入库产品</p>
                    <Table :columns="entryTable.tableColumns"
                        size="small"
                        :data="warehouseForwardEntryFrom.details"
                        :border="true"
                        :stripe="true" />
                </Card>
                </Col>
            </Row>
        </Card>
    </Modal>

</template>

<script>
import { formatDateString } from '@/libs/logic';
import { number2ThousandsFormat } from '@/components/number-input/display-format';

import { getWarehouseForwardEntryDetail } from '@/api/modules/warehouse-management/warehouseEntry';

export default {
    name: 'WarehouseForwardEntryDetail',
    data() {
        return {
            show: false,
            innerSpin: false,
            entryUuid: '',
            warehouseForwardEntryFrom: {
                ownerName: '',
                record: {
                    userPersonName: '',
                    warehouseForwardEntryRecordUuid: '',
                    warehouseForwardEntryRecordProject: '',
                    warehouseForwardEntryRecordContactNumber: '',
                    warehouseForwardEntryRecordBillCode: '',
                    warehouseForwardEntryRecordStatus: '',
                    warehouseForwardEntryRecordCreateAt: '',
                    warehouseForwardEntryRecordBatchCode: ''
                },
                details: []
            },
            entryTable: {
                tableColumns: [
                    { title: '产品编号', key: 'warehouseForwardEntryDetailProductCode', align: 'center' },
                    { title: '名称', key: 'warehouseForwardEntryDetailProductName', align: 'center' },
                    {
                        title: '预售价',
                        key: 'warehouseForwardEntryDetailPrice',
                        align: 'center',
                        render: (h, params) => {
                            return h('div', [
                                h('span', {}, number2ThousandsFormat(params.row.warehouseForwardEntryDetailPrice, 4, '￥'))
                            ]);
                        }
                    },
                    { title: '入库数量', key: 'warehouseForwardEntryDetailAmount', align: 'center' },
                    {
                        title: '金额',
                        key: 'warehouseForwardEntryDetailMoney',
                        align: 'center',
                        render: (h, params) => {
                            return h('div', [
                                h('span', {}, number2ThousandsFormat(params.row.warehouseForwardEntryDetailMoney, 4, '￥'))
                            ]);
                        }
                    }
                ]
            }
        };
    },
    computed: {
        formatWarehouseForwardEntryRecordCreateAt() {
            if (this.warehouseForwardEntryFrom.record.warehouseForwardEntryRecordCreateAt === '') {
                return '';
            }
            return formatDateString(this.warehouseForwardEntryFrom.record.warehouseForwardEntryRecordCreateAt);
        }
    },
    mounted() {

    },
    methods: {
        onShowChange(e) {
            if (e) {
                this.init();
            }
        },
        showModal(entryUuid) {
            this.entryUuid = entryUuid;
            this.show = true;
        },
        init() {
            if (this.entryUuid) {
                this.innerSpin = true;
                getWarehouseForwardEntryDetail(this.entryUuid).then(detail => {
                    this.innerSpin = false;

                    if (detail.code === 0) {
                        const rsp = detail.data;

                        this.warehouseForwardEntryFrom.ownerName = rsp.ownerName;
                        this.warehouseForwardEntryFrom.record = Object.assign(this.warehouseForwardEntryFrom.record, rsp.record);
                        this.warehouseForwardEntryFrom.details = rsp.details;
                    }
                }).catch(() => {
                    this.innerSpin = false;
                });
            }
        }
    }
};
</script>

<style scoped>
</style>
